<template>
  <div class="staff-management" style="padding:16px">
    <el-card class="card-container">
      <div slot="header" class="clearfix">
        <span>{{ $route.meta.title || "线索客户" }}</span>
      </div>
      <el-form
        ref="formreset"
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="订单时间：" prop="allTime">
          <el-date-picker
            v-model="formInline.allTime"
            type="daterange"
            range-separator="至"
            label="查询时间："
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-button type="danger" @click="handleSearch">查询</el-button>
        <el-button type="danger" plain @click="reset">重置</el-button>
        <el-button type="danger" plain v-loading="exportLoading" @click="handleExport">一键导出</el-button>
      </el-form>
    </el-card>
    <div style="height:8px; background: #edeff2"></div>
    <div style="height:8px; background: #edeff2"></div>
    <el-card class="card-container">
      <el-table
        ref="multipleTable"
        v-loading="tableLoading"
        :data="tableData"
        max-height="500"
        style="width: 100%;margin-top:10px;"
      >
        >
        <!-- <el-table-column prop="j obNo" label="工号" />-->
        <el-table-column prop="create_date" label="订单时间" min-width="120" />
        <el-table-column prop="tel" label="手机号码" min-width="100" />
        <el-table-column prop="city_name" label="城市" min-width="100" />
        <el-table-column prop="area_name" label="区县" min-width="100" />
        <el-table-column prop="mianji" label="面积" min-width="100" />
      </el-table>
      <div class="pagination" style="width:100%;text-align:center">
        <el-pagination
          style="text-align: right"
          :current-page="page"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryClueClientData } from "@/api/order";
import { export_json_to_excel } from '@/excel/Export2Excel';
export default {
  name:'clueClient',
  components: {},
  data() {
    return {
      rowData: {},
      formInline: {
        allTime: []
      },
      tableData: [],
      tableLoading: false,
      page: 1, // 分页面数
      limit: 10, // 分页条数
      total: 0,
      exportLoading:false,
      exportData:[]
    };
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    // 搜索
    handleSearch() {
      this.page = 1;
      this._queryTableList();
    },
    async _queryTableList(){
      const params = {
        is_export:0,
        page: this.page,
        limit: this.limit,
        type:1//类型（1：毛单线索客户；2：活动订单）
      };
      if(this.formInline.allTime&&this.formInline.allTime.length>0){
        params.start_date = this.formInline.allTime[0]
        params.end_date = this.formInline.allTime[1]
      }else{
        params.start_date = ''
        params.end_date = ''
      }
      this.tableLoading = true;
      const res = await queryClueClientData(params);
      if (res && res.status===200 && res.data.error_code === 0) {
        this.tableLoading = false;
        this.tableData = res.data.data.list || [];
        this.total = res.data.data.page.total_number || 0;
        this.tableLoading = false
      } else {
        this.$message.error(res.data.error_msg);
        this.tableLoading = false;
      }
    },
    // 重置
    reset() {
      this.$refs.formreset.resetFields();
      this.page = 1;
      this.total = 0;
      this.handleSearch()
    },
    // 修改一页大小
    handleSizeChange(val) {
      this.page = 1;
      this.limit = val;
      this._queryTableList();
    },
    // 第几页
    handleCurrentChange(val) {
      this.page = val;
      this._queryTableList();
    },
    // 导出
    fetchExportOrders(val, cb) {
      const params = {
        page: this.page,
        limit: 9999,
        is_export:1,
        type:1//类型（1：毛单线索客户；2：活动订单）
      }
      if(this.formInline.allTime&&this.formInline.allTime.length>0){
        params.start_date = this.formInline.allTime[0]
        params.end_date = this.formInline.allTime[1]
      }else{
        params.start_date = ''
        params.end_date = ''
      }
      queryClueClientData(params).then(res => {
        if (res && res.status===200 && res.data.error_code === 0) {
          if (res.data.data.list.length > 0) {
            res.data.data.list.forEach((item, index) => {
              // 此处对数据进行处理(后续)
              this.exportData.push(item)
            })
            cb && cb.call()
          } else {
            this.$message.error('未查询到符合要求的数据')
            this.exportLoading = false
          }
        } else {
          //this.$message.error(res.error_msg)
          this.exportData = []
          this.exportLoading = false
        }
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    handleExport() {
      this.exportLoading = true
      const tHeader = [
        '订单时间',
        '手机号码',
        '城市',
        '区县',
        '面积',
      ]
      // 上面设置Excel的表格第一行的标题
      const filterVal = [
        'create_date',
        'tel',
        'city_name',
        'area_name',
        'mianji',
      ]
      this.fetchExportOrders('export', () => {
        const list = this.exportData // 把data里的exportData存到list
        this.exportData = []
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '线索客户订单列表')
        this.exportLoading = false
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.staff-management {
  min-height: 1100px;
  overflow: auto;
  .pagination {
    margin: 8px 0;
    float: right;
  }
}
.active {
  color: #008000;
}
.inactive {
  color: #ff0000;
}
</style>
